import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import Carousel from 'components/ui/carousel';
import CategoryLink from 'components/categoryLink';
import Card from 'scy/Card';
import CategoryTile from 'scy/CategoryTile';
import { AccentH5 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';
import { textCenter, tablet_width50, width100 } from 'scy/utils.mod.scss';
import { flex, centerItems, centerContent } from 'scy/flex.mod.scss';
import {
  absolute,
  top_0,
  left_0,
  right_0,
  bottom_0
} from 'scy/position.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './featured.mod.scss';

export default function Featured({ carousel, tiles }) {
  return (
    <Card className={styles.container} paddingClass={null}>
      <div className={tablet_width50}>
        <CarouselImages items={carousel} />
      </div>
      <div className={styles.icons}>
        <MobileIcons categories={tiles} />
      </div>
      <div className={styles.tiles}>
        {tiles.map(category => (
          <CategoryTile
            key={category.name}
            linkClassName={styles.tile}
            backgroundClassName={classnames(
              absolute,
              top_0,
              left_0,
              right_0,
              bottom_0,
              flex,
              centerItems,
              centerContent
            )}
            category={category}
          />
        ))}
      </div>
    </Card>
  );
}

const CarouselImages = ({ items }) => (
  <Carousel
    slidesToShow={1}
    slidesToScroll={1}
    responsive={[]}
    arrows={false}
    autoplay
    infinite
    dots
  >
    {items
      .filter(item => !!item.image)
      .map((item, idx) => (
        <div key={`${item.image}-${idx}`}>
          <CarouselImage {...item} />
        </div>
      ))}
  </Carousel>
);

const CarouselImage = ({ image, link, type }) => {
  if (link) {
    return type === 'product' || type === 'category' ? (
      <Link to={link}>
        <img src={image} className={width100} />
      </Link>
    ) : (
      <a href={link}>
        <img src={image} className={width100} />
      </a>
    );
  } else {
    return <img src={image} className={width100} />;
  }
};

const MobileIcons = ({ categories }) =>
  categories.map(({ name, tag, url, small_image }) => (
    <CategoryLink key={tag} tag={tag} url={url}>
      <div className={padding.sm}>
        <img src={small_image} alt={name} className={styles.icon} />
      </div>
      <AccentH5
        className={classnames(uppercase, textCenter)}
        marginClass={classnames(margin.top_0, margin.bottom_xs)}
      >
        {name}
      </AccentH5>
    </CategoryLink>
  ));
